import addToCart from './addToCart';
import updateQuantity from './updateQuantity';
import cartEditItem from './cartEditItem';
import { plusQuantity, minusQuantity } from './plusMinusQuantity';
import interactionBlocker from './interactionBlocker';
import AddToBag from '../../components/CartATB';

export default () => {
  if (window.location.pathname !== '/cart') {
    customElements.define('add-to-bag', AddToBag);
  }

  document.addEventListener('submit', function (e) {
    if (e.target.matches('form[action^="/cart/add"]')) {
      e.preventDefault();
      const cartButton = e.target.querySelector('button[type="submit"]');
      if (cartButton && cartButton.dataset.waitlistOpen === 'true') return;
      interactionBlocker(true);
      if (e.target.matches('form[data-edit-cart-item="true"]')) {
        return cartEditItem(e.target);
      }
      addToCart(e.target);
    }
  });

  document.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
    });
  });

  document.querySelector('[data-cart]').addEventListener('click', function (e) {
    if (e.target.matches('[data-cart-remove]')) {
      const cartProduct = e.target.closest('.CartProduct');
      const itemId = cartProduct.dataset.id;
      interactionBlocker(true);
      updateQuantity(0, itemId);
    }
  });

  document.querySelector('[data-cart]').addEventListener('change', function (e) {
    e.preventDefault();
    if (e.target.matches('[name="quantity"]')) {
      const cartProduct = e.target.closest('.CartProduct');
      const value = e.target.value;
      const itemId = cartProduct.dataset.id;
      interactionBlocker(true);
      updateQuantity(value, itemId);
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.matches('[data-quantity-plus]')) {
      plusQuantity(e);
    } else if (e.target.matches('[data-quantity-minus]')) {
      minusQuantity(e);
    }
  });
};
